import * as React from 'react'
import { ReactElement } from 'react'
import { InjuryPanelProps } from './FormContainer'
import { Field } from '@fluentui/react-components'
import BaseCombobox from '../../Combobox/BaseCombobox'

type Props = InjuryPanelProps & {}

const DropdownOptions = ['Ja', 'Nee', 'Onbekend']

export default function OccupationalAccidentPanel(props: Props): ReactElement {
    return (
        <div className={props.styles.formRow}>
            <Field label="Bij therapeut geweest" orientation={props.orientation}>
                <BaseCombobox
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
            <Field label="Ziekenhuisopname" orientation={props.orientation}>
                <BaseCombobox
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
        </div>
    )
}
